import { render } from "./ShareBox.vue?vue&type=template&id=c58741e2"
import script from "./ShareBox.vue?vue&type=script&lang=js"
export * from "./ShareBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__